// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2bq8i","modalForm":"UpgradeEpcsModal_modalForm__1-xYR","modalFooter":"UpgradeEpcsModal_modalFooter__wh5UY"};